// https://support.crowdin.com/api/language-codes/

export enum CvpLocale {
  /** French 33 */
  "fr" = "fr",

  /** English 44 */
  "en" = "en",

  /** Danish 45 */
  "da" = "da",

  /** Swedish 46 */
  "sv" = "sv",

  /** Norwegian Bokmal 47 */
  "nb" = "nb",

  /** Polish 48 */
  "pl" = "pl",

  /** German 49 */
  "de" = "de",
}
